import React from "react"
import { View } from "react-native"
import { Body } from "@/components/standard/BFText"
import { type EmptyAnalysisListType } from "@/types/analysisTypes"
import HeartIcon from "@/assets/icons/heart_vector.svg"
import { router } from "expo-router"
import { PrimaryDarkButton } from "@/components/buttons/CommonButtons"
import ChartIcon from "@/assets/icons/chart-bar.svg"

interface EmptyAnalysisListProps {
  type: EmptyAnalysisListType
}

const EmptyAnalysisList = ({ type }: EmptyAnalysisListProps) => {
  if (type === "all") {
    return (
      <View className="relative flex justify-center flex-1 px-6">
        <View className={"flex items-center justify-center"}>
          <ChartIcon width={28} height={28} />
          <Body className="text-lightest text-center mt-3 mb-2">
            {"Start analyzing a property to get started."}
          </Body>
        </View>

        <PrimaryDarkButton
          testID={"analyze-a-property-button"}
          title={"Analyze a Property"}
          onPress={() => {
            router.push("/analyze")
          }}
          className="mb-8 bottom-2 absolute"
          style={{ alignSelf: "center", width: 330 }}
        />
      </View>
    )
  }

  if (type === "favorites") {
    return (
      <View className="flex items-center justify-center flex-1">
        <HeartIcon width={28} height={28} />
        <Body className="text-lightest text-center mt-3">
          {
            "Favorite your property so you can quickly\nview your leads that you’re interested in!"
          }
        </Body>
      </View>
    )
  }

  return null
}

export default EmptyAnalysisList
